export default [
  {
    path: '/login',
    name: 'loginApp',
    component: () => import(/* webpackChunkName: "loginApp" */'@/views/auth/login/login-app'),
  },
  {
    path: '/search',
    name: 'searchApp',
    component: () => import(/* webpackChunkName: "searchApp" */'@/views/auth/login/comp/search-app'),
    children: [
      {
        path: '',
        name: 'searchId',
        component: () => import(/* webpackChunkName: "searchId" */'@/views/auth/login/comp/search-id'),
      },
      {
        path: 'searchIdComplete',
        name: 'searchIdComplete',
        component: () => import(/* webpackChunkName: "searchIdComplete" */'@/views/auth/login/comp/search-id-complete'),
      },
      {
        path: 'searchPw',
        name: 'searchPw',
        component: () => import(/* webpackChunkName: "searchPw" */'@/views/auth/login/comp/search-pw'),
      },
      {
        path: 'searchPwNew',
        name: 'searchPwNew',
        component: () => import(/* webpackChunkName: "searchPwNew" */'@/views/auth/login/comp/search-pw-new'),
      },
    ],
  }
]
